var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',_vm._b({attrs:{"min":0},on:{"change":_vm.handleChange},model:{value:(_vm.id),callback:function ($$v) {_vm.id=$$v},expression:"id"}},'el-input-number',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }